const e = (r) => r ? Array.isArray(r) ? r.length > 0 : Object.keys(r).length > 0 : !1;
export {
  e as hasColumns
};
